export function If(props) {
  return props.test() ? props.children : null;
}



// WEBPACK FOOTER //
// ./src/client/app/components/util.jsx